export default "__VITE_ASSET__U5xUvri0__"